module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-32.4ed96b53.png";